<template>
  <div class="newsmore">
      <div class="outline">
        <div class="main-outline">NEWS</div>
      </div>
      <div class="newsmore-wrapper">
        <div class="container">
          <div v-for='n in users.length' :key='n' class="box">
            <newsBox :p_id="n-1 + ''"/>
          </div>
        </div>
      </div>
  </div>
</template>

<script>

import newsBox from '@/components/news/newsBox.vue'
import users from '../assets/news/news-list.json'

export default {
  name: 'news',
  props: {
    msg: String
  },
  components: {
    newsBox
  },
  data () {
    return {
      users: users
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .newsmore{
    background-color: #E4E4E4;
    padding-top: 8.3vw;
    padding-bottom: 5.3vw;
    padding-left: 20px;
    padding-right: 20px;
    .outline{
      padding-top: 22px;
      padding-bottom: 22px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #3B3B3B;
      margin: 0 0.8vw;

      .main-outline{
        font-size: 3.1vw;
        font-weight: Bold;
      }

      @media (max-width: 550px) {
        flex-direction: column;

        .main-outline{
          margin-left: 0;
          font-size: 16vw;
          position: relative;
          top: 3vw;
        }
      }
      .view-more{
        font-size: 1.6vw;
        font-weight: Bold;
        a, a:visited{
          text-decoration: none;
          color: #3B3B3B;
        }
      }
    }
  }
  .newsmore-wrapper{
    overflow: hidden;
  }
  .container{
    width: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    .box{
      width:  23vw;
      height: 40vw;
      min-width: 300px;
      min-height: 520px;
      margin-right: 1vw;
      margin-bottom: 1vw;
    }
    @media (max-width: 550px) {
      padding-top: 25vw;
      .box{
        width: 94vw;
        height: 160vw;
        margin-top: -20vw;
      }
    }
  }

</style>
